<div class="flow-control background">
  <h1 mat-dialog-title>Hallo {{ data.name }}</h1>
  <p>Ben je klaar met uw afspraak met {{ data.meetingPerson }}?</p>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="onClose(true)">Ja</button>
    <button mat-button mat-dialog-close (click)="onClose(false)">Nee</button>
  </div>
</div>
